module.exports = __webpack_public_path__ + "static/img/17.677cbaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/17.png
// module id = czWZ
// module chunks = 0